/*!
 * jquery.simpler-modal.js by Dale
 */
/**
 * Created with JetBrains PhpStorm.
 * User: daletan
 * Date: 10/11/12
 * Time: 10:54 AM
 * Copyright 1stdibs.com, Inc. 2013. All Rights Reserved.
 * @namespace $.fn.dibsmodal
 * also includes $.fn.getViewport
 * to use - make sure the following scss file is included in your source:
 * bunsen/scss/modules/modal.scss
 */

(function (root, factory) {
    'use strict';
    if (typeof module !== 'undefined') {
        // CommonJS
        factory(module, root, require('dibs-jquery-shim'));
    } else {
        var m = {};
        // Browser globals
        factory(m, root, root.jQuery);

        // Don't need to put jQuery on root again.
        // root.jQuery = module.exports;
    }
}(typeof window === 'undefined' ? global : window, function (module, root, $) {

    'use strict';

    var document = root.document;

    // TODO: update all references to require the new bunsen/libraries/plugins/jquery.getViewport file
    $.fn.getViewport = $.fn.getViewport || function () {
        // $(window).height() is returning incorrect values
        var viewPortWidth;
        var viewPortHeight;
        viewPortWidth = root.innerWidth ||
            document.documentElement.clientWidth ||
            document.getElementsByTagName('body')[0].clientWidth;

        viewPortHeight = window.innerHeight ||
            document.documentElement.clientHeight ||
            document.getElementsByTagName('body')[0].clientHeight;

        return {
            'width': viewPortWidth,
            'height': viewPortHeight
        };
    };

    $.fn.dibsModal = $.fn.dibsModal || function (options) {
        return new Modal(options);
    };

    $.fn.dibsDialog = $.fn.dibsDialog || function (options) {
        return new Dialog(options);
    };

    // global.document.body.style.msTextCombineHorizontal: 11+ (http://stackoverflow.com/questions/18907131/detecting-ie11-using-css-properties)
    // global.document.documentMode: 7-10
    var isIE = (typeof document.body.style.msTextCombineHorizontal !== 'undefined') || !!document.documentMode;

    function Modal(opts) {
        var isOpen = false;
        var self = this;
        var $body = $('body');
        var $window = $(window);
         // used to keep track of modal content
        var storage = {};
        // current modal name
        var cName = '';
        // var $container;
        var $modalInnerContent;
        var $modalClose;
        var callBacks;
        var options;
        var classPrefix;
        var createMethods;

        self.$container = [];
        self.$modalContent = [];

        // callback functions
        callBacks = {
            'onClose': {}
        };
        options = $.extend(true, {
            // TODO: refactor all modal_ids references to modalIds
            modal_ids: {
                modal: 'modalOverlay',
                contentWrapper: 'modalOverlay-content-wrapper',
                content: 'modalOverlay-content',
                innerContent: 'modalOverlay-inner-content',
                close: 'modalOverlay-close',
                bg: 'modalOverlay-bg'
            },
            classPrefix: '',
            toggle : {
                mayClose : true
            },
            position: null
        }, opts);

        // TODO: really get this modal_ids stuff refactored to modalIds
        options.modalIds = $.extend(options.modal_ids, options.modalIds);

        if (options.classPrefix) {
            classPrefix = options.classPrefix;
        }

        createMethods = {
            addClassPrefix: function ($el, suffix) {
                if ($el && $el.length && classPrefix && suffix) {
                    $el.addClass(classPrefix + '-' + suffix);
                }
                return $el;
            },
            modal: function () {
                var id = options.modalIds.modal;
                var $modal = $body.find('#' + id);
                var $div;
                if (!$modal.length) {
                    $div = $(document.createElement('div'))
                        .attr('id', id)
                        .addClass('modal');
                    $div = this.addClassPrefix($div, 'modal');
                    $body.append($div);
                    $modal = $div;
                }
                self.$container = $modal;
                // = $container
                return this;
            },
            modalContent: function () {
                var contentWrapperId = options.modalIds.contentWrapper;
                var contentId = options.modalIds.content;
                var $contentWrapper;
                var $div;
                self.$modalContent = self.$container.find('#' + contentId);
                if (!self.$modalContent.length) {
                    $contentWrapper = $('<div>')
                        .attr('id', contentWrapperId)
                        .addClass('modal-content-wrapper');
                    $div = $(document.createElement('div'))
                        .attr('id', contentId)
                        .addClass('modal-content');
                    $div = this.addClassPrefix($div, 'modal-content');

                    self.$contentWrapper = $contentWrapper;
                    self.$modalContent = $div;

                    $contentWrapper.append($div);
                    self.$container.append($contentWrapper);
                }

                $modalInnerContent = this.modalInnerContent();
                $modalClose = this.modalClose();
                self.$modalContent.append($modalInnerContent, $modalClose);
                return this;
            },
            modalClose: function () {
                var closeId = options.modalIds.close;
                var $close;
                var $closeLink;
                $modalClose = self.$modalContent.find('#' + closeId);
                if (!$modalClose.length) {
                    $close = $(document.createElement('div'))
                        .attr('id', closeId)
                        .addClass('modal-close');
                    $closeLink = $(document.createElement('a'))
                        .attr({
                            id: 'modalOverlay-close-btn',
                            href: '#close-modal'
                        })
                        .addClass('modal-close-btn');
                    $close = this.addClassPrefix($close, 'modal-close');
                    $closeLink = this.addClassPrefix($closeLink, 'modal-close-btn');
                    $closeLink.append(this.closeButton());
                    $close.html($closeLink);
                    $modalClose = $close;
                }
                if (!options.toggle.mayClose) {
                    $modalClose.hide();
                }
                return $modalClose;
            },
            modalInnerContent: function () {
                var innerContentId = options.modalIds.innerContent;
                $modalInnerContent = self.$modalContent.find('#' + innerContentId);
                if (!$modalInnerContent.length) {
                    $modalInnerContent = $(document.createElement('div'))
                        .attr('id', innerContentId)
                        .addClass('modal-inner-content');
                    $modalInnerContent = this.addClassPrefix($modalInnerContent, 'modal-inner-content');
                }
                return $modalInnerContent;
            },
            closeButton: function () {
                var $icon;
                $icon = $('<i>', {
                    'class': 'bunsen-icon bunsen-icon-close pua-icon' + (classPrefix ? ' ' + classPrefix + '-icon-close' : '')
                });

                return $icon;
            }
        };

        this.options = options;

        this.getPosition = function () {
            return options.position;
        };

        this.getBgId = function () {
            return options.modalIds.bg;
        };

        this.getBody = function () {
            return $body;
        };

        /**
         * Store a copy of the modal UI ($content) under a key name
         * @param {string} name The key to store the modal $content in
         * @param {object} $content jQuery dom element
         * @returns {Modal}
         */
        this.update = function (name, $content) {
            // set current modal name
            cName = name;
            if (!storage[name]) {
                storage[name] = !$content ? storage[name] : $content;
            } else if (name && $content) {
                // update the stored object with new $content
                storage[name] = $content;
            }
            $modalInnerContent.html(storage[name]);
            $.publish('modal:update', [self, self.$modalContent]);
            return this;
        };

        /**
         * Opens up a modal
         * @param eventName {String} Optional. The event to fire, otherwise defaults to "modal:show"
         * @returns {*}
         */
        this.show = function (eventName) {
            this.preventScrolling();
            isOpen = true;
            self.$container.addClass(cName).show();
            self.center();
            $.publish((eventName || 'modal:show'), [self, self.$modalContent]);
            return this;
        };

        this.hideModal = function () {
            self.$container.hide();
        };

        this.showModal = function () {
            self.$container.show();
        };

        this.check = function (name) {
            return !!storage[name];
        };

        this.close = function (e) {
            if (e) {
                e.preventDefault();
            }
            // Allow page scrolling
            if (this.enableScrolling) {
                this.enableScrolling();
            }

            self.$container.hide().removeClass(cName);
            if (callBacks.onClose[cName]) {
                callBacks.onClose[cName]();
            }
            isOpen = false;
            cName = '';
            return false;
        };

        this.enableClose = function () {
            options.toggle.mayClose = true;
            $modalClose.show();
            return this;
        };

        this.disableClose = function () {
            $modalClose.hide();
            options.toggle.mayClose = false;
            return this;
        };

        this.onClose = function (name, callback) {
            callBacks.onClose[name] = callback;
        };

        this.check = function (name) {
            return storage[name];
        };

        function init() {
            createMethods.modal().modalContent();
            self.modalBg();
            self.$container.on('click', '#modalOverlay-close-btn', function (e) {
                $.publish('modal:close', e);
                return false;
            });
            $.subscribe('modal:close', function (e) {
                if (!options.toggle.mayClose) {
                    $.publish('modal:close:prevented', e);
                    return;
                }
                self.close(e);
            });
        }

        function checkScrollBar() {
            var outer = $('<div class="modal-measure-scrollbar" />').prependTo($body);
            var inner = $('<div class="inner" />').appendTo(outer);
            var width = outer.width() - inner.width();
            outer.remove();

            if (width > 0) {
                var css = '.modal-open #header .header-wrap { max-width:' + ($('#page').width() + width) + 'px;} .modal-open, .modal-open #header .header-search-box, .modal-open #header #toggleNavSearch { margin-right: ' + width + 'px; }';
                $('head').append('<style type="text/css">' + css + '</style>');
            }
        }

        $window.bind({
            resize: function () {
                self.center();
            },
            keyup: function (e) { // use keyCode for x-browser
                if (!isOpen) {
                    return;
                }
                if (e.keyCode === 27) { // escape
                    $.publish('modal:close', e);
                }
            }
        });

        checkScrollBar();
        init();

        return this;
    }

    Modal.fn = Modal.prototype;

    Modal.fn.center = function () {
        var h = this.$modalContent.height();
        var winH = $.fn.getViewport().height;
        var top = (winH - h) / 2;
        if (top < 0) {
            top = 0;
        }
        this.$modalContent.css('top', top);
        this.$container.css('position', 'fixed');
    };
    Modal.fn.modalBg = function () {
        var bgId = this.getBgId();
        var $container = this.$container;
        var $modalBg = $container.find('#' + bgId);
        if (!$modalBg.length) {
            var $div = $(document.createElement('div'))
                .attr('id', bgId)
                .addClass('modal-bg');
            $modalBg = $div;
            $container.append($div);
        }
        $modalBg.bind('click', function (e) {
            e.preventDefault();
            $.publish('modal:close', e);
        });
        return this;
    };
    Modal.fn.preventScrolling = function () {
        var ids = this.options.modalIds;
        var bgId = ids.bg;
        var $content = $("#" + ids.content);
        var $innerContent = $("#" + ids.innerContent);

        this.getBody().addClass('modal-open')
            .on("touchmove.modal-scroll", function (e) {
                //don't allow scrolling for touch devices
                if ($innerContent.height() > $content.height()) {
                    //but do allow divs inside modal to scroll
                    if (e.target.id === bgId) {
                        e.preventDefault();
                    }
                    //also do not allow page to scroll behind modal when scrollable div reaches limit
                    if ($content.scrollTop() === 0) {
                        $content.scrollTop(1);
                    } else if ($content.scrollTop() + $content.innerHeight() === $content[0].scrollHeight) {
                        $content[0].scrollTop -= 1;
                    }
                } else {
                    //don't allow any scrolling at all if modal doesn't scroll
                    //unless it has an inner list which needs to scroll
                    if ($(e.target).parents(".alpha-modal-lists-wrapper").length === 0) {
                        e.preventDefault();
                    }
                }
            });
    };
    Modal.fn.enableScrolling = function () {
        this.getBody().removeClass('modal-open').off("touchmove.modal-scroll");
    };

    function Dialog(opts) {
        Modal.call(this, opts);
    }

    Dialog.fn = Dialog.prototype = new Modal();
    Dialog.fn.center = function () {
        var top;
        var left;
        var elementPosition;
        var rightOverlap;
        var verticalOffset = 10;
        var position = this.getPosition();

        // if jquery element passed in, use it to position the dialog
        // jQuery = $
        if (position instanceof $) {
            // start at element position
            elementPosition = position.offset();
            top = elementPosition.top;
            left = elementPosition.left;
            // horizontally center dialog at element
            left += (position.width() / 2);
            left -= (this.$modalContent.width() / 2);
            // do not allow dialog to overlap right edge of screen
            rightOverlap = left + this.$modalContent.width() - $.fn.getViewport().width;
            if (rightOverlap > 0) {
                left -= rightOverlap;
            }
            // do not allow dialog to overlap left edge of screen
            if (left < 0) {
                left = 0;
            }
            // find vertical position above element
            top = top - this.$modalContent.height();
            top -= verticalOffset;
            // if above position of off screen, position below element
            if (top < $(window).scrollTop()) {
                top = elementPosition.top;
                top += position.height();
                top += verticalOffset;
            }
            // ie hack. ugh..
            if (isIE) {
                left -= 15;
            }

            // if top & left offsets passed in, use them
        } else if (position && position.top && position.left) {
            top = position.top;
            left = position.left;
        }

        if (top !== undefined && left !== undefined) {
            this.$modalContent.css('top', top);
            this.$modalContent.css('left', left);
            this.$container.css('position', 'static');
            this.$modalContent.css('position', 'absolute');
        }
    };
    Dialog.fn.modalBg = function () {
        var $modalBg = this.$container.find('#' + this.getBgId());
        // if unique id is not set for modal, background from another modal on page may exist
        if ($modalBg.length) {
            $modalBg.remove();
        }
        this.$modalContent.addClass('is-dialog');
        return this;
    };
    Dialog.fn.preventScrolling = function () {
        // do nothing - we do not want to prevent scrolling for dialogs
    };

    module.exports = Modal;

}));


//////////////////
// WEBPACK FOOTER
// ./~/bunsen/libraries/plugins/jquery.simpler-modal.js
// module id = 474
// module chunks = 4 6 7 8 9 12 22 30 55 56